/**
 * The words for "you are disabled in every organisation you belong to" (Task #3008). Shown by the
 * blocked screen for `ALL_ORGANISATIONS_DISABLED`: from the BFF's org-less 403
 * (`ACCOUNT_DISABLED` with `scope: 'every_organisation'`), or from the organisation list
 * (`only_disabled_memberships`).
 */
export const ALL_ORGANISATIONS_DISABLED_TITLE = 'Access disabled'
export const ALL_ORGANISATIONS_DISABLED_MESSAGE =
  'Your account has been disabled. An administrator in your organisation can turn your access back on.'
